import React from 'react';

export default function LoadingIndicator({loading}) {
  if (!loading){
    return null;
  }

  return (
      <div>
        <span className="spinner-border spinner-border-sm text-primary" role="status"
            aria-hidden="true"></span>
        &nbsp;刷新中 ...
        <br/>
        <br/>
      </div>

  )

}
